import { tsValidateString } from '@nu-art/ts-common';
import { validateProjectId } from '../../validators.js';
import { PermissionDBGroup } from '../../consts.js';
const Validator_ModifiableProps = {
    projectId: validateProjectId,
    namespace: tsValidateString(50),
};
const Validator_GeneratedProps = {
    _auditorId: tsValidateString()
};
export const DBDef_PermissionDomain = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.0'],
    dbKey: 'permissions--domain',
    frontend: {
        group: PermissionDBGroup,
        name: 'domain',
    },
    backend: {
        name: 'permissions--domain',
    },
    entityName: 'PermissionDomain',
    lockKeys: ['projectId'],
    dependencies: {
        projectId: {
            fieldType: 'string',
            dbKey: 'permissions--project',
        }
    }
};
//# sourceMappingURL=db-def.js.map